import AuthForm from '../components/AuthPage/AuthForm.jsx';
import DeviceIdentifiers from '../components/RegulatoryInformation/DeviceIdentifiers.jsx';
import RegulatoryInformation from '../components/RegulatoryInformation/RegulatoryInformation.jsx';
import LanguageSelector from '../components/HeaderControls/LanguageSelector.jsx';
import {
  PageContainer,
  FormPanel,
  TopControls,
  MobileLogo,
  FormContainer,
  CardInfoAccordion,
  DeviceIdentifiersFooter,
  VersionText,
  InformationPanel,
  DesktopLogo,
  InformationContent,
  PanelIntroduction,
  PanelTitle,
  PanelText,
  RegulatoryInformationContainer,
} from '../components/AuthPage/styles.js';
import { useAppConfig } from '../context/AppConfigContext.jsx';
import { useTranslation } from '../context/TranslationContext.jsx';
import sondaLogo from '../images/logo-main.svg';
import appInfo from '../../package.json';

const AuthPage = () => {
  const { features } = useAppConfig();
  const { translate } = useTranslation();
  const shouldDisplayVersion = Boolean(features?.showVersionBanner);

  return (
    <PageContainer>
      <FormPanel>
        <TopControls>
          <LanguageSelector />
        </TopControls>

        <FormContainer>
          <MobileLogo src={sondaLogo} alt={translate('authForm.accessibility.sondaLogo')} />
          <AuthForm />
          <CardInfoAccordion>
            <RegulatoryInformation variant="card" />
          </CardInfoAccordion>
          {shouldDisplayVersion ? (
            <VersionText className="cardVersion" component="p">
              v{appInfo.version}
            </VersionText>
          ) : null}
        </FormContainer>

        <DeviceIdentifiersFooter>
          <DeviceIdentifiers />
        </DeviceIdentifiersFooter>
        {shouldDisplayVersion ? (
          <VersionText className="desktopVersion" component="p">
            v{appInfo.version}
          </VersionText>
        ) : null}
      </FormPanel>

      <InformationPanel>
        <DesktopLogo src={sondaLogo} alt={translate('authForm.accessibility.sondaLogo')} />

        <InformationContent>
          <PanelIntroduction>
            <PanelTitle>{translate('authPage.heading')}</PanelTitle>
            <PanelText>{translate('authPage.description')}</PanelText>
          </PanelIntroduction>

          <RegulatoryInformationContainer>
            <RegulatoryInformation variant="embedded" />
          </RegulatoryInformationContainer>
        </InformationContent>

        <DeviceIdentifiers />
      </InformationPanel>
    </PageContainer>
  );
};

export default AuthPage;
